import { useState } from "react";

/**
 * 🧩 **관리자 메뉴 그림 아이콘** (2026-09-27).
 *
 * 운영자도 글보다 그림을 먼저 본다 — 아이 화면과 같은 손그림(같은 격자에서 잘랐다)을 메뉴에 얹는다.
 * 그림은 관리자 제 출처(`/art/ui/act/`)에서 받는다 — 웹 출처로 가면 CORS·캐시 함정이 있다(docs: dev-api-cors-edgebase).
 * 못 받으면 `emoji` 로 — 뜻은 남는다. 장식이라 `alt=""`(이름은 옆 글자가 말한다).
 */
export function ScreenIcon({ art, emoji, size = 22, className }: { art: string; emoji: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className={className} aria-hidden="true">
        {emoji}
      </span>
    );
  }
  return (
    <img
      className={className}
      src={`/art/ui/act/${art}.webp`}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain", verticalAlign: "middle" }}
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
}
